<template>
  <fh-container>
    <fh-title>Cerrando Sesión</fh-title>

    <fh-card>
      <div class="grey--text">
        Debería ser redirigido a la página de inicio de sesión prontamente.
      </div>

      <div class="grey--text">
        En caso contrario, puede darle click al botón de abajo.
      </div>

      <v-row justify="center" class="mt-3">
        <v-btn :to="{ name: 'Login' }">
          Volver a Iniciar Sesión
        </v-btn>
      </v-row>
    </fh-card>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import FhTitle from '@/components/FhTitle'
import { mapActions, mapGetters } from 'vuex'
import FhCard from '@/components/FhCard'

export default {
  name: 'Logout',
  components: { FhCard, FhContainer, FhTitle },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn'
    ]),
    query () {
      return this.$route.query
    }
  },
  methods: {
    ...mapActions('auth', [
      'logout'
    ])
  },
  async mounted () {
    try {
      if (this.isLoggedIn) {
        await this.logout()
      }
    } finally {
      this.$router.push({
        name: 'Login',
        query: this.query
      })
    }
  }
}
</script>

<style scoped>

</style>
